import { getSocket } from "../socket/index.js";
import { vm } from "../socket/config.js";
import { getUserInfo, updateVersion } from "../socket/events.js";
import { hashProject } from "../utils/project-fingerprint.js";
import {
    isLoadingProject,
    isPauseEventHandling,
    getOriginalProjectJSON,
} from "./overrides.js";
import { showTopNotification } from "../ui/notification.js";

const CHECK_INTERVAL_MS = 30000;

let checking = false;
let pendingMismatchHash = null;
let hasMatchedRoomOnce = false;

const askServerForState = (socket) =>
    new Promise((resolve) => {
        socket.emit("checkProjectHash", {}, (response) => {
            resolve(response ?? null);
        });
    });

const isSafeToCheck = () => !isLoadingProject() && !isPauseEventHandling();

const shouldPublishInstead = (serverHash, lastWriter) => {
    if (!serverHash) return true;
    if (lastWriter && lastWriter === getUserInfo().uid) return true;
    return !lastWriter && hasMatchedRoomOnce;
};

const runCheck = async () => {
    if (checking || !isSafeToCheck()) return;

    const socket = getSocket();
    if (!socket?.connected) return;

    checking = true;
    try {
        const localJson = getOriginalProjectJSON();
        if (!localJson) return;

        const [localHash, serverState] = await Promise.all([
            hashProject(localJson),
            askServerForState(socket),
        ]);

        const serverHash = serverState?.hash ?? null;

        if (serverHash && serverHash === localHash) {
            hasMatchedRoomOnce = true;
            pendingMismatchHash = null;
            return;
        }
        if (!isSafeToCheck()) return;

        if (shouldPublishInstead(serverHash, serverState?.lastWriter)) {
            pendingMismatchHash = null;
            updateVersion(vm);
            return;
        }

        if (pendingMismatchHash !== serverHash) {
            pendingMismatchHash = serverHash;
            return;
        }
        pendingMismatchHash = null;

        console.warn(
            "Project drifted from the room's canonical state; resyncing.",
        );
        showTopNotification(
            "Sincronizando el proyecto con el resto de la sala…",
            4000,
        );
        socket.emit("requestResync", {});
    } catch (e) {
        console.error("Error checking project sync:", e);
    } finally {
        checking = false;
    }
};

export const startSyncWatchdog = () => {
    setInterval(runCheck, CHECK_INTERVAL_MS);
};
